import { ConjunctionV1 } from 'bones/utils/queryBuilder/migrate/v1/constants';
import { DataV1 } from 'bones/utils/queryBuilder/migrate/v1/types';
import { ConjunctionV2 } from 'bones/utils/queryBuilder/migrate/v2/constants';
import {
  DataV2,
  ExpressionV2,
  SubExpressionV2,
} from 'bones/utils/queryBuilder/migrate/v2/types';

const cartesian = <T>(...input: T[][]) =>
  input.reduce<T[][]>(
    (acc, arr) => acc.flatMap((i) => arr.map((j) => [...i, j])),
    [[]]
  );

export const v2 = (data: DataV1): DataV2 => {
  const newData: DataV2 = {
    query: {
      expressions: [],
      conjunction: ConjunctionV2.OR,
    },
    fullGraph: data.fullGraph,
  };

  if (data.query.conjunction === ConjunctionV1.AND) {
    // [ [A1] OR [B] ]
    // AND
    // [ [A2] AND [A3] ]
    // AND
    // [ [B2] AND [B3] ]
    // AND
    // [ [A4] OR [A5] ]
    // -> [ A1 A2 A3 B2 B3 A4 ] OR [ B A2 A3 B2 B3 A4 ] OR [ A1 A2 A3 B2 B3 A5 ] OR [ B A2 A3 B2 B3 A5]

    // collect all AND requirements
    // collect combinations of OR requirements
    // for each OR combination, create a sub-expression with the combination and AND requirements
    const andExpressions: ExpressionV2[] = [];
    const orExpressions: ExpressionV2[][] = [];
    data.query.expressions.forEach(({ conjunction, expressions }) => {
      if (!expressions.length) {
        // do nothing
      } else if (conjunction === ConjunctionV1.AND) {
        andExpressions.push(...(expressions as unknown as ExpressionV2[]));
      } else {
        orExpressions.push(expressions as unknown as ExpressionV2[]);
      }
    });

    const cartesianExpressions = cartesian(...orExpressions);
    newData.query.expressions.push(
      ...cartesianExpressions.map<SubExpressionV2>((expressions) => ({
        expressions: expressions.concat(andExpressions),
        conjunction: ConjunctionV2.AND,
      }))
    );
  } else {
    // [ [A1] OR [B] ]
    // OR
    // [ [A2] AND [A3] ]
    // OR
    // [ [A4] OR [A5] ]
    // -> [ A1 ] OR [ B ] OR [A2 A3] OR [ A4 ] OR [ A5 ]

    // promote OR expressions to sub-expressions
    // add AND blocks as-is
    data.query.expressions.forEach(({ conjunction, expressions }) => {
      if (conjunction === ConjunctionV1.OR) {
        expressions.forEach((expression) => {
          newData.query.expressions.push({
            expressions: [expression as unknown as ExpressionV2],
            conjunction: ConjunctionV2.AND,
          });
        });
      } else {
        newData.query.expressions.push({
          expressions: expressions as unknown as ExpressionV2[],
          conjunction: ConjunctionV2.AND,
        });
      }
    });
  }

  return newData;
};
